import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { back } from '../../helpers/dataServer';
import send from './assets/send.svg';
import { UserContext } from '../auth/context/UserContext';
import Modal from '../Modal/Modal';
import { Clientes } from '../catalogo/components/clientes';
import { useCliente } from '../catalogo/hooks/useCliente';

import '../catalogo/components/BtnPedido/BtnNuevoUser.css';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ListPerfilesNuevoUser } from './ListPerfilesNuevoUser';

import invitacionImg from '../../public/invitacion2.png';

import { useGlobalStore } from '../../Hooks/useGlobalStore';

export const NuevosUsuarios = () => {
  const [email, setEmail] = useState('');
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const { dataUser } = useContext(UserContext);
  const { token } = dataUser;
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const [perfilesSeleccionados, setPerfilesSeleccionados] = useState([]);
  const { getClientById, clienteId } = useCliente();
  const { data: isMobile } = useGlobalStore('isMobile');
  const [isLoading, setIsLoading] = useState(false);

  const [perfilSeleccionado, setPerfilSeleccionado] = useState(null);
  const [usuarioPerfil, setUsuarioPerfil] = useState([]);

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleClienteSeleccionado = (cliente) => {
    if (!cliente) return;

    setClienteSeleccionado(cliente);
    setEmail(cliente.e_mail || '');
    setModalOpen(false);
  };

  useEffect(() => {
    if (clienteSeleccionado) {
      getClientById(clienteSeleccionado);
    }
  }, [clienteSeleccionado]);

  const handlePerfilChange = (perfil) => {
    setPerfilesSeleccionados((prev) => {
      if (prev.some((p) => p.id === perfil.id)) {
        return prev.filter((p) => p.id !== perfil.id);
      } else {
        return [...prev, perfil];
      }
    });
  };

  const enviarCorreo = async () => {
    setIsLoading(true);

    if (!email.trim() || !usuarioPerfil) {
      Swal.fire({
        title: 'Error',
        text: 'Por favor, ingresa un correo electrónico válido y selecciona un perfil.',
        icon: 'error',
      });
      setIsLoading(false);
      return;
    }

    const requestBody = {
      email,
      clienteId: clienteId?.id,
      perfilesIds: usuarioPerfil,
    };

    try {
      const res = await fetch(`${back}/nuevousuario`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(requestBody),
      });

      if (res.status === 401) {
        setIsLoading(false);
        Swal.fire({
          title: 'Error',
          text: 'No tienes autorización para realizar esta acción.',
          icon: 'error',
        });
        return;
      }

      if (res.status === 500) {
        setIsLoading(false);
        Swal.fire({
          title: 'Error en la solicitud de invitación',
          text: 'El servidor devolvió un error 500. Intente nuevamente más tarde o contacte a soporte.',
          icon: 'error',
        });
        return;
      }

      if (res.ok) {
        setIsLoading(false);
        Swal.fire({
          title: 'Invitación enviada con éxito',
          text: 'La invitación estará vigente 1 día a partir de este momento.',
          icon: 'success',
        });
        setEmail('');
        setPerfilSeleccionado(null);
        navigate('/auth/login');
      } else {
        setIsLoading(false);
        Swal.fire({
          title: 'Error',
          text: 'Hubo un problema al enviar la invitación.',
          icon: 'error',
        });
      }
    } catch (error) {
      console.error('Error al enviar la invitación:', error);
      setIsLoading(false);
      Swal.fire({
        title: 'Error',
        text: 'No se pudo conectar con el servidor.',
        icon: 'error',
      });
    }
  };

  return (
    <div className="newUserContainer">
      <div className="addNewUserContainer">
        <h1 className="titleNewUser">Invitación a Nuevo Usuario</h1>
        <p className="paragraphNewUser">
          Por favor, ingrese el correo electrónico del usuario que desea
          invitar.
        </p>
        <p className="paragraphNewUser">
          Tenga en cuenta que la invitación tendrá una validez de{' '}
          <u> 24 horas.</u>
        </p>

        <p className="paragraphNewUserClie">
          Si el usuario es un cliente, puede asociarlo a una cuenta existente
          desde aquí.
        </p>
        <button className="btnIniciarCompra" onClick={() => setModalOpen(true)}>
          <FontAwesomeIcon icon="fa-solid fa-users" />
          <hr />
          Seleccionar Cliente
        </button>

        {clienteId && (
          <div className="cliente-info">
            <p>
              <strong>Cliente seleccionado:</strong> {clienteId.denominacion}
            </p>

            <strong>Asignar Perfil:</strong>

            <p className="paragraphNewUser">
              Seleccionar perfil deseao para el nuevo Usuario
            </p>

            <ListPerfilesNuevoUser
              usuarioPerfil={usuarioPerfil}
              onPerfilChange={setUsuarioPerfil}
              modoMultiple={true}
            />
          </div>
        )}

        {modalOpen && (
          <Modal titulo={'Clientes'} cerrarModal={closeModal}>
            <Clientes
              cerrarModal={closeModal}
              onClienteSeleccionado={handleClienteSeleccionado}
            />
          </Modal>
        )}
        <div className="userInvitacion">
          <article className="cardNewUser">
            <header>
              <p className="titleNewUserCard">Email de usuario a invitar</p>
            </header>
            <div className="">
              <input
                type="email"
                id="search-input"
                className="search-input"
                style={{ width: 310 }}
                value={email.trim() !== '' ? email : clienteId?.e_mail || ''}
                onChange={handleEmailChange}
              />
            </div>
            <div className="">
              <button
                className="btnSendNewUser"
                onClick={enviarCorreo}
                disabled={isLoading}
              >
                {isLoading ? (
                  <FontAwesomeIcon
                    icon={faSpinner}
                    spin
                    style={{ marginRight: 8 }}
                  />
                ) : (
                  <img src={send} alt="" className="svgSend" />
                )}
                {isLoading ? 'Enviando invitación...' : 'Enviar invitación'}
              </button>
            </div>
          </article>
        </div>
      </div>
      {!isMobile && (
        <div className="addNewUserContainerImg">
          {/* <img className="imagen_logo" src={invitacionImg} alt="Invitación" /> */}

          <img
            className="imagen_invitacion"
            src={invitacionImg}
            alt="Invitación"
          />
        </div>
      )}
    </div>
  );
};
